const translations = {
  fr: {
    proposition: {
      proposedCampaignPageTitle: 'Campagnes proposées',
      campaignStart: 'Début campagne',
      nbOpp: 'Nb occ.',
      noPropositions: 'Aucune proposition',
      unavailablePropositions: 'Les propositions ne sont pas disponibles',
      accept: 'Accepter',
      decline: 'Refuser',
      propositionAccepted: 'La proposition a été acceptée',
      propositionAcceptedError: 'Une erreur est survenue lors de l\'acceptation de la proposition',
      propositionDeclined: 'La proposition a été refusée',
      propositionDeclinedError: 'Une erreur est survenue lors du refus de la proposition',
    },
  },
  en: {
    proposition: {
      proposedCampaignPageTitle: 'Proposed Campaigns',
      campaignStart: 'Campaign Start',
      nbOpp: 'Nb Spots',
      noPropositions: 'No proposals',
      unavailablePropositions: 'Proposals are unavailable',
      accept: 'Accept',
      decline: 'Decline',
      propositionAccepted: 'The proposal has been accepted',
      propositionAcceptedError: 'An error occured when accepting the proposal',
      propositionDeclined: 'The proposal has been declined',
      propositionDeclinedError: 'An error occured when declining the proposal',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/advertisers/modules/propositions/i18n/proposition.js